<div class="container-fluid">
    <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12">
            <div class="finzy-row1">
                <div>
                    <img [src]="rowOne.successLogo" alt="success logo" />
                </div>
                <div class="success-message">
                    <p>{{rowOne.successMsg}}</p>
                </div>
                <div class="success-info-message">
                    <p [innerHTML]="rowOne.successInfoMsg"></p>
                </div>
            </div>

            <div class="row d-flex justify-content-center">
                <div class="col-sm-12 col-md-6">
                    <table class="table">
                        <tbody>
                            <tr *ngFor="let val of rowTwo">
                                <ng-container *ngIf="val.rowName && val.rowValue">
                                    <td class="table-left">{{val.rowName}}</td>
                                    <td class="table-right">
                                        <app-horizontal-loader *ngIf="val.rowValue === undefined">
                                        </app-horizontal-loader>
                                        <strong>{{val.rowValue}}</strong>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <ng-container *ngIf="!isComingFromPartnerRetailer">
                <div class="finzy-row3">
                    <button class="goto-dashboard-btn" (click)="buttonHandler()">GO TO DASHBOARD</button>
                </div>
            </ng-container>
        </div>
    </div>
</div>